
import { Box, Button, Checkbox, CircularProgress, FormControlLabel, Grid, IconButton, TextField, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { vendorRegister } from "../State/Auth/Action";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { InputAdornment } from "@mui/material";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { Visibility, VisibilityOff } from "@mui/icons-material";


const VendorRegister = ({ handleClose, switchToLogin }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { auth } = useSelector((store) => store);
  const [showPassword, setShowPassword] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    otp: "",
    password: "",
  });

  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setShowPassword(false)
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Allow only digits in phone
    if (name === "phone" && !/^\d*$/.test(value)) return;

    if (name === "otp" && !/^\d*$/.test(value)) return;

    // Validate email
    if (name === "email" && value && !/^\S+@\S+\.\S+$/.test(value)) {
      setError("Invalid email");
    } else {
      setError("");
    }

    setFormData({ ...formData, [name]: value });
  };

  const handleSendOtp = () => {
    if (formData.phone.length === 10) {
      // Simulate sending OTP
      setOtpSent(true);
    } else {
      toast.error("Enter valid 10-digit phone number");
    }
  };

  const handleVerifyOtp = () => {
    if (formData.otp === "1234") {
      setOtpVerified(true);
    } else {
      toast.error("Invalid OTP");
    }
  };

  const handleSubmit = (e) => {
    if (!formData.name.trim() || !formData.email.trim() || !formData.phone || !formData.password.trim()) {
      toast.error("Please fill all field !!")
    }
    e.preventDefault();
    dispatch(vendorRegister(formData, navigate))

  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: '20vh',
        bgcolor: '#fff',
        pt: 3,
        pb: 3,
      }}

    >
      <Box
        sx={{
          width: { xs: '90%', sm: '450px' },
          bgcolor: 'background.paper',
          borderRadius: '8px',
          boxShadow: '0 4px 20px #6b7280',
          overflow: 'hidden',
        }}
      >
        {/* Banner Section */}
        <Box sx={{ width: '100%', p: 2, textAlign: 'center', bgcolor: '#f0f0f0', borderBottom: '1px solid #e0e0e0' }}>
          <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#449AEF', textTransform: 'uppercase' }}>
            Inarifashion
          </Typography>
        </Box>

        {/* Login Form Section */}
        <Box sx={{ p: 2 }}>
          <Typography variant="h5" sx={{ mb: 2, fontWeight: 'bold', textAlign: 'center' }}>
            Register
          </Typography>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  required
                  id="name"
                  name="name"
                  label="Full Name"
                  fullWidth
                  value={formData.name}
                  onChange={handleChange}
                  autoComplete="given-name"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  id="email"
                  name="email"
                  label="Email"
                  type="email"
                  fullWidth
                  value={formData.email}
                  onChange={handleChange}
                  autoComplete="email"
                  error={!!error}
                  helperText={error}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  id="phone"
                  name="phone"
                  label="Phone Number"
                  fullWidth
                  value={formData.phone}
                  onChange={handleChange}
                  inputProps={{ maxLength: 10 }}
                  InputProps={{
                    endAdornment: otpVerified ? (
                      <InputAdornment position="end">
                        <CheckCircleIcon sx={{ color: "green" }} />
                      </InputAdornment>
                    ) : null,
                  }}
                />
              </Grid>

              {!otpSent && (
                <Grid item xs={12}>
                  <Button
                    fullWidth
                    variant="outlined"
                    sx={{ borderColor: "#ef4444", color: "#ef4444", "&:hover": { color: "white" } }}
                    onClick={handleSendOtp}
                  >
                    Send OTP
                  </Button>
                </Grid>
              )}

              {otpSent && !otpVerified && (
                <>
                  <Grid item xs={12}>
                    <TextField
                      required
                      id="otp"
                      name="otp"
                      label="Enter OTP"
                      fullWidth
                      value={formData.otp}
                      onChange={handleChange}
                      inputProps={{ maxLength: 4 }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      variant="contained"
                      sx={{ backgroundColor: "#ef4444", color: "#fff" }}
                      onClick={handleVerifyOtp}
                    >
                      Verify OTP
                    </Button>
                  </Grid>
                </>
              )}

              {otpVerified && (
                <Grid item xs={12}>
                  <TextField
                    required
                    id="password"
                    name="password"
                    type={showPassword ? "text" : "password"}
                    value={formData.password}
                    onChange={handleChange}
                    label="Password"
                    fullWidth
                    autoComplete="current-password"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              )}
              {/* Checkbox for terms - Keeping for consistency, but not in original login flow for email/password */}
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="agreeTerms"
                      color="primary"
                    />
                  }
                  label={
                    <Typography variant="body2">
                      By continuing, I agree to the <a href="#" style={{ color: '#ef4444', textDecoration: 'none' }}>Terms of Use</a> & <a href="#" style={{ color: '#ef4444', textDecoration: 'none' }}>Privacy Policy</a> and I am above 18 years old.
                    </Typography>
                  }
                  sx={{ mt: -1 }}
                />
              </Grid>
              <Grid item xs={12}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{
                    py: 1,
                    bgcolor: '#6b7280',
                    '&:hover': {
                      bgcolor: '#4b5563',
                    },
                    color: '#fff',
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    fontSize: '1rem',
                  }}
                >
                  {auth.isLoading ? <CircularProgress size={24} /> : "REGISTER"}
                </Button>
              </Grid>
            </Grid>
          </form>
          <Typography variant="body2" sx={{ mt: 1, textAlign: 'center' }}>
            Already have a account? <span style={{ color: '#ef4444', textDecoration: 'none', cursor: "pointer" }} onClick={switchToLogin}>Login</span>
          </Typography>
          <Typography variant="body2" sx={{ mt: 1, textAlign: 'center' }}>
            Have trouble logging in? <a href="#" style={{ color: '#ef4444', textDecoration: 'none' }}>Get help</a>
          </Typography>
        </Box>
      </Box>
      {/* {auth.isLoading && <Loader />} */}
    </Box>
  );
};

export default VendorRegister;

